import { Actions, createComposable, Getters, Module, Mutations } from 'vuex-smart-module'
import { getEquipment, getEquipmentById, createEquipment, updateEquipment, deleteEquipment } from '@/api'

export class EquipmentState {
  equipment = null
}

export class EquipmentGetters extends Getters {
  get getEquipment() {
    return this.state.equipment
  }

  getEquipmentById(id) {
    return this.state.equipment?.find((item) => item.id === id)
  }
}

export class EquipmentMutations extends Mutations {
  setEquipment(payload) {
    this.state.equipment = payload
  }

  addEquipment(payload) {
    if (!this.state.equipment) {
      this.state.equipment = []
    }
    this.state.equipment.push(payload)
  }

  updateEquipment(payload) {
    if (!this.state.equipment) return
    const index = this.state.equipment.findIndex((item) => item.id === payload.id)
    if (index !== -1) {
      this.state.equipment[index] = payload
    }
  }

  removeEquipment(id) {
    if (!this.state.equipment) return
    this.state.equipment = this.state.equipment.filter((item) => item.id !== id)
  }
}

export class EquipmentActions extends Actions {
  async fetchEquipment() {
    try {
      const response = await getEquipment()
      this.mutations.setEquipment(response.data || [])
    } catch (error) {
      console.error('Failed to fetch equipment:', error)
      throw error
    }
  }

  async fetchEquipmentById(id) {
    try {
      const response = await getEquipmentById(id)
      const equipment = response.data
      if (equipment) {
        this.mutations.updateEquipment(equipment)
      }
      return equipment
    } catch (error) {
      console.error('Failed to fetch equipment:', error)
      throw error
    }
  }

  async createEquipment(data) {
    try {
      const response = await createEquipment(data)
      const equipment = response.data
      this.mutations.addEquipment(equipment)
      return equipment
    } catch (error) {
      console.error('Failed to create equipment:', error)
      throw error
    }
  }

  async updateEquipment(id, data) {
    try {
      const response = await updateEquipment(id, data)
      const equipment = response.data
      this.mutations.updateEquipment(equipment)
      return equipment
    } catch (error) {
      console.error('Failed to update equipment:', error)
      throw error
    }
  }

  async deleteEquipment(id) {
    try {
      await deleteEquipment(id)
      this.mutations.removeEquipment(id)
    } catch (error) {
      console.error('Failed to delete equipment:', error)
      throw error
    }
  }
}

export const equipmentModule = new Module({
  state: EquipmentState,
  getters: EquipmentGetters,
  mutations: EquipmentMutations,
  actions: EquipmentActions,
})

export const useEquipmentModule = createComposable(equipmentModule)
